(function () {

	'use strict';

	/*global $:true, cologic:true */

	// Frontend filter (event category / general category / "from month") and sort for the
	// "Event Crawler" content element (CType "event_crawler"). The engine is the generic
	// cologic.initCrawlerControls (cologic-crawlerControls.js); this maps
	// EventCrawler.fluid.html's data-* attribute contract onto it.

	let cologicEventCrawler = {

		initEventCrawler: function (rootSelector) {
			let lang = document.documentElement.lang || undefined;
			let monthFormat = (window.Intl && Intl.DateTimeFormat)
				? new Intl.DateTimeFormat(lang, {month: 'long', year: 'numeric'})
				: null;

			cologic.initCrawlerControls(rootSelector, {
				card: '.event-card',
				filterControl: '.event-crawler-filter',
				filterAttribute: 'data-crawler-filter',
				sortControl: '.event-crawler-sort',
				grid: '.event-crawler-grid',
				slider: '.event-crawler-slider .slider',
				sliderViewClass: 'crawler-view-slider',
				filters: [
					// Options built from the categories that actually occur, with the translated
					// labels the template renders into data-event-category-label.
					{name: 'eventCategory', dataKey: 'eventCategory', match: 'equals', populate: {valueKey: 'eventCategory', labelKey: 'eventCategoryLabel', sort: 'locale'}},
					{name: 'categories', dataKey: 'categories', match: 'inList', populate: {valueKey: 'categories', labelKey: 'categoryTitles', sort: 'locale'}},
					// Offers the months events start in; keeps events that END in or after the
					// chosen month, so running multi-day events stay visible.
					{name: 'monthFrom', dataKey: 'endMonth', match: 'monthFrom', populate: {valueKey: 'month', sort: 'value', label: function (month) {
						let parts = String(month).split('-');
						if (!monthFormat || parts.length !== 2) return month;
						return monthFormat.format(new Date(Number(parts[0]), Number(parts[1]) - 1, 1));
					}}}
				],
				sorts: {
					// "default" = the server order (by time filter, or the editor's manual order).
					'default': {dataKey: 'position', type: 'number', dir: 'asc'},
					date_asc: {dataKey: 'start', type: 'number', dir: 'asc'},
					date_desc: {dataKey: 'start', type: 'number', dir: 'desc'},
					title_asc: {dataKey: 'headline', type: 'locale', dir: 'asc'},
					title_desc: {dataKey: 'headline', type: 'locale', dir: 'desc'}
				},
				defaultSort: 'default'
			});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicEventCrawler);
}());
